<template>
  <div class="label-value-container px-3 pb-1">
    <span class="label" :class="labelClass">{{ label }}:</span>
    <span class="pr-1"></span>
    <a v-if="linkConfig" :href="linkConfig.url" :target="linkConfig.target || '_blank'"
      :class="valueClass">{{ getValue }}
    </a>
    <span v-else class="value" :class="valueClass">{{ getValue }}</span>
  </div>
</template>

<script>
export default {
  name: 'LabelValue',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: false
    },
    labelClass: {
      type: String,
      default: ''
    },
    valueClass: {
      type: String,
      default: ''
    },
    linkConfig: {
      type: Object,
      default: undefined
    },
    containerClass: {
      type: String,
      default: ''
    },
    showEmptyAsNA: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getValue() {
      const isEmpty = this.value?.toString().trim() === '' || this.value === null || this.value === undefined;
      if (isEmpty) {
        return this.showEmptyAsNA ? 'N/A' : '';
      }
      return this.value;
    }
  }
}
</script>

<style scoped>
.label-value-container {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  max-width: 100%;
  box-sizing: border-box;
}
.label {
  color: #6a6a6a;
  flex-shrink: 1;
  min-width: 0;
  margin-right: 8px;
  white-space: nowrap;
  box-sizing: border-box;
}

.value {
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-all;
  overflow-wrap: break-word;
  box-sizing: border-box;
}
.hyperlink { 
  text-decoration: underline;
  color: #000000;
  
}
</style>